export const tableMixins = {
    data() {
        return {
            endpoint: this.$endpoints.products,
            items: [],
            requiredApiParams: {},
            apiParams: {},
            sortBy: '',
        }
    },
    mounted() {
        this.getItems()
    },
    methods: {
        searchField(data) {
            if (data) {
                this.apiParams.search = data
                this.apiParams.page = 1
            } else {
                delete this.apiParams.search
            }
            this.getItems()
        },
        filterTable(data, underscore = false) {
            let dataKey = Object.keys(data)
            if (data[dataKey]) {
                this.apiParams[`filter[${underscore ? '_' : ''}${dataKey}]`] = data[dataKey]
            } else {
                delete this.apiParams[`filter[${underscore ? '_' : ''}${dataKey}]`]
            }
            this.apiParams.page = 1
            this.getItems()
        },
        sortTable(ctx) {
            if (ctx.sortBy === '') return false
            let sortBy = ctx.sortBy === 'dateStatus' ? 'createdAt' : ctx.sortBy 
            if (this.sortBy && this.sortBy !== `sort[${sortBy}]`) {
                delete this.apiParams[this.sortBy]
            }
            this.sortBy = `sort[${sortBy}]`
            this.apiParams[this.sortBy] = ctx.sortDesc ? 'desc' : 'asc'
            this.getItems()
        },
        getItems() {
            this.$store.dispatch('getItems', {
                endpoint: this.endpoint,
                params: this.requiredApiParams
            }).then(response => {
                this.items = response
            })
        }
    }
}

export const paginationMixin = {
    data() {
        return {
            // TODO: change value quantityProductOnPage and quantityProductVariations
            quantityProductOnPage: 10,
            quantityProductVariations: [10, 25, 50, 100, 200],
            apiParams: {
                page: 1,
                perPage: 10
            },
            settingsPaginationFromApi: {
                perPage: 10,
                page: 1
            },
        }
    },
    methods: {
        updatePagination(set) {
            this.apiParams.page = set.page
            this.apiParams.perPage = set.perPage
            this.getItems()
        },
        getItems() {
            if (this.apiParams.perPage === undefined) {
                this.apiParams.perPage = this.quantityProductOnPage
            }
            let params = {}
            if (this.routePagination) {
                params = this.syncApiWithRoute()
            } else {
                params = this.apiParams
            }

            this.$store.dispatch('getItems', {
                endpoint: this.endpoint,
                params: {
                    ...params,
                    ...this.requiredApiParams
                }
            }).then(response => {
                this.settingsPaginationFromApi = Object.assign({}, response)
                delete this.settingsPaginationFromApi.items
                this.items = response.items ? response.items : response
            })
        }
    }
}

export const routePaginationMixin = {
    data() {
        return {
            routePagination: true
        }
    },
    created() {
        if (Object.keys(this.$route.query).length > 0) {
            this.apiParams = {...this.$route.query}
            this.sortBy = Object.keys(this.$route.query).filter(name => name.includes('sort') ? name : null)[0]
        }
    },
    watch: {
        '$route.query': function(newVal, oldVal) {
            if (this.$helper.deepEqualMethod(oldVal, this.apiParams)) {
                this.apiParams = {...newVal}
                if (Object.keys(newVal).length < 1) {
                    this.$router.go(-1)
                    return false
                }
                this.getItems()
            }
        }
    },
    methods: {
        syncApiWithRoute() {
            this.$router.push({query: {...this.apiParams}})
            return this.$route.query
        }
    }
}

export const rowSelectMixin = {
    data() {
        return {
            checkboxesColumn: {
                key: 'checkboxes',
                label: '',
                variant: 'column-xs'
            },
            actionsColumn: {
                key: 'actions',
                label: ''
            },
            selectedCheckbox: [],
            allCheckboxes: false,
        }
    },
    computed: {
        disabledBtn() {
            return (this.selectedCheckbox.length === 0)
        }
    },
    methods: {
        // TODO: remove computed select method
        // computedFields(columns) {
        //     if (this.selectMod === true) {
        //         if (!columns.includes(this.checkboxesColumn)) {
        //             columns.unshift(this.checkboxesColumn)
        //         }
        //         this.resetCheckbox()
        //         return columns.filter(column => column !== this.actionsColumn)
        //     }
        //     if (!columns.includes(this.actionsColumn)) {
        //         columns.push(this.actionsColumn)
        //     }
        //
        //     return columns.filter(column => column !== this.checkboxesColumn)
        // },
        selectedAll() {
            if (!this.allCheckboxes) {
                let arr = []
                this.items.map(item => {
                    arr.push(item.id)
                    this.selectedCheckbox = arr
                })
            } else {
                this.selectedCheckbox = []
            }
        },
        resetCheckbox() {
            this.selectedCheckbox = []
            this.allCheckboxes = false
        },
    },
    watch: {
        selectedCheckbox(newVal) {
            if (newVal.length < this.settingsPaginationFromApi.count) {
                this.allCheckboxes = false
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/tableMixins.js